<template lang="pug">
  .flow-builder-connector-button(:class="buttonClasses")
    .move-button-icon.hover-primary
      maximize-2-icon.template-connector-tool-move.icon-sm(style="transform:rotate(-45deg);")
    .delete-button-icon(@click="deleteTemplateConnector")
      trash-2-icon.icon-sm.hover-danger
    .text-truncate(v-if="disabled")
      span(:class="buttonClasses") {{ title || 'Sin título' }}
      .flow-builder-connector-anchor(:id="connectorId", :block_id="block_id", :template_id="template_id", :element_id="element_id")
    template(v-else)
      b-form-row.align-items-center
        b-col
          vue-tribute(:options="tributeOpts")
            b-form-input(
              size="sm",
              :class="buttonClasses"
              :value="title",
              placeholder="Título de botón",
              @input="updateTemplateConnector({ attribute: 'title', value: $event })"
            )
        b-col(cols="auto")
          block-connector(
            v-bind="$props",
            button-only,
            pill,
            size="sm",
            @change="updateButtonConnector",
            @change:type="update({ attribute:'type', value: $event || $event.target._value })",
            @change:delay="updateTemplateConnector",
            editable
          )
</template>

<script>
import connectorProps from '@/data/connector-props'
import _debounce from 'lodash.debounce'

export default {
  mixins: [connectorProps],
  data () {
    return {
      loading: false
    }
  },
  computed: {
    // button text length limit = 20
    buttonClasses () {
      return {
        'text-secondary': !this.title,
        'text-danger': this.title.length > 20,
        editable: !this.disabled
      }
    },
  },
  created () {
    this.updateTemplateConnector = _debounce((data) => {
      this.update(data)
      this.$message.success('Actualizado')
    }, 1000, { leading: false, trailing: true })
    this.deleteTemplateConnector = _debounce(() => {
      const connector = JSON.parse(JSON.stringify(this.$props))

      this.deleteConnector(this.block_id, this.template_id, connector)
    }, 0, { leading: false, trailing: true })
  },
  methods: {
    update({ attribute, value }) {
      const connector = JSON.parse(JSON.stringify(this.$props))
      connector[attribute] = value

      this.updateConnector(this.block_id, this.template_id, connector)
    },
    updateButtonConnector({ attribute, value, flow_id, next_block_id }) {
      const connector = JSON.parse(JSON.stringify(this.$props))
      connector.flow_id = flow_id
      connector.next_block_id = next_block_id
      connector[attribute] = value

      this.updateConnector(this.block_id, this.template_id, connector)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/colors.scss';

  .flow-builder-connector-button {
    display: block;
    width: 100%;
    border-radius: 10px;
    background-color: $light-white;
    color: $dark;
    text-align: center;
    padding: 7px;
    position: relative;

    .delete-button-icon {
      position: absolute;
      top: 0;
      left: 0;
      width: 0;
      height: 0;
      border-radius: 50%;
      background-color: $message-bg;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: .1s;
      border: 0 solid $secondary;
      cursor: pointer;
      opacity: 0;
      color: $secondary;
    }

    &:hover {
      .delete-button-icon {
        top: -15px;
        left: -15px;
        width: 30px;
        height: 30px;
        border: 1px solid $secondary;
        opacity: 1;
      }
    }

    &:hover.editable {
      .move-button-icon .icon-sm {
        display: inline-block;
      }
    }

    .move-button-icon {
      width: 40px;
      height: 100%;
      background: transparent;
      position: absolute;
      top: 0;
      left: -40px;
      color: $secondary;
      display: flex;
      align-items: center;
      justify-content: center;

      .icon-sm {
        cursor: move;
        display: none;
      }
    }

    &:not(.editable) {
      padding: 7px 28px;

      .delete-button-icon {
        display: none;
      }
    }

    .flow-builder-connector-anchor {
      position: absolute;
      width: 14px;
      height: 14px;
      right: 7px;
      top: calc(50% - 6px);
      border-radius: 50px;
    }

    span {
      position: relative;
      width: 100%;
    }


  }
</style>
